import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import styles from 'src/components/Tile/TileIcon.scss';


const TileIcon = function ({ icon: Icon, classModifier }) {
  const classList = classNames(
    styles['tile-icon'],
    styles[`tile-icon--${classModifier}`]
  );

  return <Icon className={ classList } viewBox="0 0 24 24" />;
};

TileIcon.propTypes = {
  classModifier: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired
};

export default TileIcon;
